import ApiError from '../../../../entities/api-error/ApiError'
import { Vehicle } from '../../../../entities/vehicle/Vehicle'
import DashboardActionTypes from './DashboardActionTypes'

export interface RequestVehicle {
  type: DashboardActionTypes.REQUEST_VEHICLE;
}

export function requestVehicle(): RequestVehicle {
  return {
    type: DashboardActionTypes.REQUEST_VEHICLE,
  }
}

export interface RequestVehicleSuccess {
  type: DashboardActionTypes.REQUEST_VEHICLE_SUCCESS;
  payload: {
    vehicles: Vehicle[];
  }
}

export function requestVehicleSuccess({
  vehicles,
}: RequestVehicleSuccess['payload']): RequestVehicleSuccess {

  return {
    type: DashboardActionTypes.REQUEST_VEHICLE_SUCCESS,
    payload: {
      vehicles,
    },
  }
}

export interface RequestVehicleFailure {
  type: DashboardActionTypes.REQUEST_VEHICLE_FAILURE;
  payload: {
    error: ApiError;
  }
}

export function requestVehicleFailure({
  error,
}: RequestVehicleFailure['payload']): RequestVehicleFailure {

  return {
    type: DashboardActionTypes.REQUEST_VEHICLE_FAILURE,
    payload: {
      error,
    },
  }
}
